// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.songwriter-link-wrapper .content-header .left-data {
  flex-basis: 100%;
}
.songwriter-link-wrapper .content-header .right-data {
  min-width: 0;
}
.songwriter-link-wrapper .catalog-button-link {
  align-self: flex-end;
  padding-top: 4rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/SongwriterScene/SongwriterCatalogBuilderScene/index.scss"],"names":[],"mappings":"AAEI;EACE,gBAAA;AADN;AAII;EACE,YAAA;AAFN;AAME;EACE,oBAAA;EACA,iBAAA;AAJJ","sourcesContent":[".songwriter-link-wrapper {\n  .content-header {\n    .left-data {\n      flex-basis: 100%;\n    }\n\n    .right-data {\n      min-width: 0;\n    }\n  }\n\n  .catalog-button-link {\n    align-self: flex-end;\n    padding-top: 4rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
